// features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    // Check if user exists in localStorage and if they have a token
    isAuthenticated: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.token ? true : false,
    user: localStorage.getItem('user') ? {
      ...JSON.parse(localStorage.getItem('user')),
      accessToken: Cookies.get('accessToken') || null, // Add accessToken from cookies
    } : {},
    permissions: localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : []
  },
  reducers: {
    loginReducer: (state, action) => {
      // Store token in cookies
      Cookies.set('accessToken', action.payload.token, { expires: 7 }); // Set cookie to expire in 7 days

      // localStorage.setItem('accessToken', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    permissionReducer: (state, action) => {
      // Save permissions in localStorage
      localStorage.setItem('permissions', JSON.stringify(action.payload));
      state.permissions = action.payload;
    },
    logoutReducer: (state) => {
      // Remove user data and token from localStorage
      // localStorage.removeItem('accessToken');
      Cookies.remove('accessToken');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
      state.isAuthenticated = false;
      state.user = {};
      state.permissions = [];
    },
    checkAuth: (state) => {
      // Check if the user is authenticated using localStorage
      state.isAuthenticated = localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).token ? true : false;
    },
  },
});

export const { loginReducer, permissionReducer, logoutReducer, checkAuth } = authSlice.actions;
export default authSlice.reducer;
